import { Component, OnInit } from '@angular/core';
import { SharedDataService } from '../shared/services/shared-data.service';
import { TitleService } from '../shared/services/title.service';
import { ClientBillingBackupFileConfigurationService } from '../shared/api/services';
import { Party } from '../shared/api/models';
import { ActivatedRoute, Router, ParamMap, UrlSegment, RouterEvent, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { matchClientPartyRow } from '../shared/classes/helpers';
@Component({
  selector: 'client-config',
  templateUrl: './client-config.component.html',
  styleUrls: ['./client-config.component.scss']
})
export class ClientConfigComponent implements OnInit {
  public matchClientPartyRow = matchClientPartyRow;
  public aviClientId: string = null;
  public selectedClient: Party = null;
  public showSpinner: boolean = false;

  private curChildUrl: UrlSegment[] = null;

  constructor(
    public sharedDataService: SharedDataService,
    private _titleService: TitleService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this._titleService.Subtitle = 'Client Config Backup Fields';

    router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(e => {
        if (route.firstChild && route.firstChild.snapshot.params['clientId']) {
          this.aviClientId =  route.firstChild.snapshot.params['clientId'];
          this.softSetSelectedClient();
          this.curChildUrl = route.firstChild.snapshot.url;
        } else {
          this.curChildUrl = null; // We've navigated to page without a child component, set this to null
        }
      });
  }

  async ngOnInit() {

    try {
      this.showSpinner = true;
      await this.sharedDataService.PopulateAviClientIds();
      this.softSetSelectedClient();
      this.showSpinner = false;
    } catch (error) {
      this.sharedDataService.HandleError(error);
      this.showSpinner = false;
    }

  }

  onSelectedClientChange() {
    // grab the path segments in the current URL, assume the lastone [1] is the clientID segment, and navigate after changing it to selected client id.
    if (!this.curChildUrl) { return; }
    let paths = this.curChildUrl.map( url => url.path);
    paths[1] = this.selectedClient.clientParty.mailStop;
    this.router.navigate(paths, {relativeTo: this.route, replaceUrl: true, skipLocationChange: false });
  }

  softSetSelectedClient() {
    if (!this.aviClientId) { return; }
    let client = this.sharedDataService.clientParties.filter(c => c.clientParty.mailStop === this.aviClientId)[0];
    if (client) {
      this.selectedClient = client;
    }
  }

}
